module.exports = __webpack_public_path__ + "static/dt_cropped-b648968eaa6c62355ca3cb7db151a182.png";